import { LeagueTableView } from '../../components';
import Radio from 'backbone.radio';

const leagueChannel = Radio.channel( 'league' );
const globalChannel = Radio.channel( 'global' );

/**
 * @desc Core Table Core My View Class
 */
export default class CoreMyLeagueTableView extends LeagueTableView {
	initListeners() {
		this.listenTo(
			globalChannel,
			'click:load:more',
			this.showMore
		);

		this.listenTo(
			this.collection,
			'get:response:leagues:count',
			this.isShowMoreButton
		);

		this.listenTo(
			this.regeneration,
			'get:response:leagues:count',
			this.isLeagueRegenerate.bind( this )
		);

		return this;
	}

	get childViewOptions() {
		return {
			...super.childViewOptions,
			rounds: this.rounds
		}
	}

	/**
	 * Fetch all data
	 * @returns {Promise.<*>}
	 */
	fetchData() {
		return this.fetchRound().then( () => {
			this.fetchCollection();
		});
	}

	fetchRound() {
		return Promise.all( [
			this.rounds.fetch()
		] );
	}

	fetchCollection() {
		return Promise.all( [
			this.collection.show_my( {
				limit: this.limit
			} ),
			this.regeneration.show_my()
		] );
	}

	/**
	 * Check is current user have regeneration leagues
	 * @returns {MyLeagueTableView}
	 */
	isLeagueRegenerate() {
		let user_league_regenerate    = this.user.get( 'league_regenerate' ) > 0,
			count_league_regeneration = this.regeneration.length > 0,
			is_league_regenerate      = user_league_regenerate && count_league_regeneration;

		leagueChannel.trigger( 'check:regeneration:bar', is_league_regenerate );

		return this;
	}
}